import React, { useEffect } from 'react';
import { Modal as AntModal } from 'antd';
import { SuccessCard } from '../../../components';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`

.ant-modal-content {
    padding: 0;
    border-radius: 24px;
}
`;

const SuccessModal = ({
    open,
    handleClose,
}) => {

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                handleClose();
            }, 2000);
        }

        // eslint-disable-next-line
    }, [open]);

    const {t} = useTranslation();

    return (
        <Modal
            centered
            closable={false}
            footer={false}
            open={open}
        >
            <SuccessCard title={t('password_send_to_email')} />
        </Modal>
    )
}

export default SuccessModal